import { AxiosPromise } from 'axios';
import { UserInfo } from '../../types/UserConfig';
import { libApiInstance } from '../axios';
import { RequestImpersonate } from './types/Support';

export function requestClientUsers(
    clientIdOrSearch: string | undefined,
    signal?: AbortSignal,
): AxiosPromise<UserInfo[]> {
    const encoded =
        clientIdOrSearch !== undefined ? encodeURIComponent(clientIdOrSearch) : undefined;
    return libApiInstance.get(`/support/clientUsers/${encoded}`, {
        signal,
    });
}

export function requestSearchClientUsers(
    search: string,
    signal?: AbortSignal,
): AxiosPromise<UserInfo[]> {
    return libApiInstance.post(
        `/support/searchClientUsers`,
        { search },
        {
            signal,
        },
    );
}

export function requestImpersonate(
    payload: RequestImpersonate,
    signal?: AbortSignal,
): AxiosPromise {
    return libApiInstance.post(`/support/impersonate/`, payload, {
        signal,
    });
}

export function requestStopImpersonating(signal?: AbortSignal): AxiosPromise {
    return libApiInstance.post(`/support/stopImpersonating/`, {
        signal,
    });
}
